/** @format */

export enum SelectContactValue {
  PLATEFORME = "plateform",
  EDI = "edi",
  MAIL = "mail",
  TELEPHONE = "telephone",
}
